module.exports = __webpack_public_path__ + "img/79601674.6dc06e58.png";